import React from 'react';
import { Grid, Typography, Box } from '@mui/material';
import MediaCard from '../../../shared/Cards/MediaCard';
import SwiperComponent from '../../../shared/SwiperComponent/SwiperComponent';
import styles from './styles';
import PointsList from '../../../shared/PointsList/PointsList';

const path = 'projects';

export default function ProjectsContent({
  projectsData,
  data: { description, points = [], list = [] },
}) {
  return (
    <Box sx={{ mx: 1, mb: 2 }}>
      <Grid container>
        <Grid item xs={12} xl={8.4}>
          <Typography variant="desktopP2" sx={styles.description}>
            {description}
          </Typography>
          <PointsList
            list={points}
            textProps={{ fontSize: { xs: 14, lg: 18 } }}
          />
        </Grid>
      </Grid>

      <Box sx={{ mt: 4 }}>
        <SwiperComponent
          hideNavigate={true}
          slidesPerView={1.3}
          spaceBetween={16}
          breakpoints={{
            700: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
            1010: {
              slidesPerView: 3,
              spaceBetween: 24,
            },
            1410: {
              slidesPerView: 4,
              spaceBetween: 24,
            },
          }}
          centeredSlides={false}
          slides={list.map(
            (media) =>
              function () {
                return (
                  <Box key={media.preview}>
                    <MediaCard
                      {...media}
                      preview={projectsData[`${path}/${media.preview}`]}
                    />
                  </Box>
                );
              },
          )}
        />
      </Box>
    </Box>
  );
}
